export default {
  title: 'Schema-uitzonderingen',
  fields: {
    status: {
      label: 'Status',
    },
    date: {
      label: 'Datum',
    },
    description: {
      label: 'Reden',
    },
    recurring: {
      label: 'Jaarlijks terugkerend',
    },
    created: {
      label: 'Aangemaakt',
      creator: 'door {{name}}',
    },
    updated: {
      label: 'Bijgewerkt',
    },
  },
  status: {
    closed: 'Gesloten',
    open: 'Open',
    paused: 'Gepauzeerd',
  },
  date: {
    all_day: 'Hele dag',
    paused_until_rest_of_day: 'Gepauzeerd tot einde van de dag',
  },
  buttons: {
    pause_availability: '+ Beschikbaarheid pauzeren',
    close_availability: '+ Beschikbaarheid sluiten',
    amend_availability: '+ Beschikbaarheid aanpassen',
    sync_from_online_shop: 'Synchroniseer vanuit Online Shop',
    close: 'Sluiten',
    delete: 'Verwijderen',
  },
  projects: {
    online_shop: 'Online Shop',
    reservations: 'Reserveringen',
    storefront: 'Etalage',
  },
  error_messages: {
    delete_failed: 'Verwijderen mislukt. Probeer het opnieuw.',
  },
  toasts: {
    sync_success: 'Succesvol gesynchroniseerd',
    sync_error: 'Synchronisatie van schema-uitzonderingen vanuit de online shop mislukt. Probeer het opnieuw.',
  },
};
